/**
 * @generated SignedSource<<2e7ee1261f0a67f525db530f7ad6b83a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightListLastUpdate_flight$data = {
  readonly lastSuccessfulUpdate: {
    readonly createdAt: string;
  } | null;
  readonly " $fragmentType": "FlightListLastUpdate_flight";
};
export type FlightListLastUpdate_flight$key = {
  readonly " $data"?: FlightListLastUpdate_flight$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightListLastUpdate_flight">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightListLastUpdate_flight",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "FlightPrice",
      "kind": "LinkedField",
      "name": "lastSuccessfulUpdate",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "createdAt",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Flight",
  "abstractKey": null
};

(node as any).hash = "c4c74facbcb008c85127eae8f7178f4c";

export default node;
